// Generated by bin/generate.sh
//
// List of supported payment types comes from the folders in src/fields/*.
// To add a new one, simply add a new folder.

const supported: Set<string> = new Set();
supported.add('bank_transfer');
supported.add('credit_card');
supported.add('konbini');
supported.add('offsite');
export default supported;
